<template>
  <div class="crm-page-header">
    <div class="crm-page-heading">
      <router-link v-if="backTo" class="crm-back-link" :to="backTo">
        <i class="la la-arrow-left"></i>
        <span>{{ backLabel }}</span>
      </router-link>
      <slot name="eyebrow"></slot>
      <h2>{{ title }}</h2>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="crm-page-actions">
      <slot name="actions"></slot>
    </div>
    <CrmTaskReminder />
  </div>
</template>

<script>
import CrmTaskReminder from "@/modules/CRM/components/CrmTaskReminder";

export default {
  name: "CrmPageHeader",
  components: { CrmTaskReminder },
  props: {
    backLabel: {
      type: String,
      default: "Voltar",
    },
    backTo: {
      type: [Object, String],
      default: null,
    },
    subtitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.crm-page-header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 20px;
}

.crm-page-heading {
  flex: 1 1 auto;
  min-width: 0;
}

.crm-page-heading h2 {
  color: #25324b;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  margin: 0;
  overflow-wrap: anywhere;
}

.crm-page-heading p {
  color: #7b8499;
  font-size: 13px;
  margin: 6px 0 0;
}

.crm-page-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  max-width: 52%;
  min-width: 0;
}

.crm-page-actions::v-deep .btn {
  white-space: normal;
}

.crm-back-link {
  align-items: center;
  color: #6b7285;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 6px;
  margin-bottom: 8px;
}

.crm-back-link:hover {
  color: #0b87c9;
  text-decoration: none;
}

@media (max-width: 767px) {
  .crm-page-header {
    display: block;
  }

  .crm-page-actions {
    justify-content: flex-start;
    margin-top: 12px;
    max-width: 100%;
  }

  .crm-page-actions::v-deep .btn {
    flex: 1 1 160px;
  }
}
</style>
